'use client';

import { Box, Columns, escapeId, NavBox, NavItem, PageNav, Text } from '@instamenu/ui-system-next';
import { MenuItem } from '../menu-item/menu-item';
import * as styles from './menu-view.css';
import { Menu, RestaurantJSON } from '@instamenu/context-checkout';
import { StyledNavBox } from './styled-nav-box';
import { palette, themeVars } from '@instamenu/ui-vanilla-extract';
import { useSearchParams } from 'next/navigation';
import { observer } from 'mobx-react-lite';

type MenuViewProps = {
  restaurant: RestaurantJSON;
  table: string;
  menuId?: string;
};

export const MenuView = observer(({ restaurant, table, menuId }: MenuViewProps) => {
  const submenuIds = useSearchParams().get('submenus')?.split(',') ?? [];

  const menu = new Menu(restaurant.currentMenu, submenuIds);

  const navItems = menu.itemGroups.map((itemGroup) => itemGroup.name ?? 'unknown');

  return (
    <PageNav items={navItems}>
      <StyledNavBox>
        <NavBox>
          {navItems.map((item, i) => (
            <NavItem label={item} key={i} />
          ))}
        </NavBox>
      </StyledNavBox>
      <Box className={styles.itemGroups}>
        {menu.itemGroups.map((itemGroup) => (
          <Columns as="section" key={itemGroup.id} id={escapeId(itemGroup.name)}>
            <Text css={{ padding: themeVars.pad[12] }} variant="h3">
              {itemGroup.name}
              {itemGroup.scheduleEnabled && !itemGroup.schedule.isActive && (
                <Text variant="caption2" css={{ color: palette.gray700 }}>
                  Currently unavailable
                </Text>
              )}
            </Text>
            <Columns className={styles.columnsFlex}>
              {itemGroup.items.map((item) => (
                <MenuItem
                  item={item}
                  restaurant={restaurant}
                  table={table}
                  menuId={menuId}
                  key={item.id}
                />
              ))}
            </Columns>
          </Columns>
        ))}
      </Box>
    </PageNav>
  );
});
